import { render, staticRenderFns } from "./NewTabLaboral.vue?vue&type=template&id=9c4f9b16&"
import script from "./NewTabLaboral.vue?vue&type=script&lang=js&"
export * from "./NewTabLaboral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports